import CompanyView from '@/views/about/CompanyView.vue'
import TrainingServicesView from '@/views/training-services/TrainingServicesView.vue'
import DevicesUtilitiesView from '@/views/devices-utilities/DevicesUtilitiesView.vue'
import AdmissionView from '@/views/Admissions/AdmissionView.vue'
import ForStudentView from '@/views/for-student/ForStudentView.vue'

import HomePageLayoutView from '@/views/homepage/HomePageLayoutView.vue'
// import HomePageView from '@/views/home/HomePageView.vue'
import QualitySystemView from '@/views/about/QualitySystemView.vue'
import StudentPilotView from '@/views/Admissions/StudentPilotView.vue'
import QandAView from '@/views/about/QandAView.vue'
import CustomerView from '@/views/about/CustomerView.vue'
import FoundationView from '@/views/about/FoundationView.vue'
import ContactView from '@/views/about/ContactView.vue'
import EvaluationFormView from '@/views/for-student/EvaluationFormView'
import ClassroomView from '@/views/devices-utilities/ClassroomView'
import ClassroomLayoutView from '@/views/for-student/ClassroomLayoutView.vue'
import LocationView from '@/views/about/LocationView.vue'
import TrainingDevicesView from '@/views/devices-utilities/TrainingDevicesView.vue'
// import LibraryView from '@/views/for-student/LibraryView.vue'
// import TrainingScheduleView from '@/views/for-student/TrainingScheduleView.vue'
import WebsiteStructureView from '@/views/web-structure/WebsiteStructureView.vue'
import NewsView from '@/views/news/NewsView.vue'
import NoInfoView from '@/views/NoInfoView.vue'
import PilotTrainingView from '@/views/training-services/PilotTrainingView.vue'
import FATrainingView from '@/views/training-services/FATrainingView.vue'
import FODPTrainingView from '@/views/training-services/FODPTrainingView.vue'
import SSTrainingView from '@/views/training-services/SSTrainingView.vue'
import AETrainingView from '@/views/training-services/AETrainingView.vue'
import ACGuidanceView from '@/views/training-services/ACGuidanceView.vue'

import TSDetailView from '@/views/training-services-details/TSDetailView.vue'
// import TrainingScheduleDetailView from '@/views/for-student/TrainingScheduleDetailView.vue'
import NewsDetailView from '@/views/news/NewsDetailView.vue'
import SPDetailView from '@/views/Admissions/SPDetailView.vue'

import LoginPage from '@/components/login/LoginPage.vue'
import BackendView from '@/views/backend/BackendView.vue'
import MenusView from '@/views/backend/MenusView.vue'
import SubMenusView from '@/views/backend/SubMenusView.vue'
import TrainingServicesBeView from '@/views/backend/TrainingServicesView.vue'
import TrainingServiceDetailsBeView from '@/views/backend/TrainingServiceDetailsView.vue'
import AdmissionBeView from '@/views/backend/AdmissionView.vue'
import TrainingSchedulesBeView from '@/views/backend/TrainingSchedulesView.vue'
import TrainingScheduleDetailsBeView from '@/views/backend/TrainingScheduleDetailsView.vue'
import MediaCategoriesBeView from '@/views/backend/MediaCategoriesView.vue'
import MediaBeView from '@/views/backend/MediaView.vue'
import UsersConfigView from '@/views/backend/users/UsersConfigView.vue'
import AccountView from '@/views/backend/users/AccountView.vue'
import UsersView from '@/views/backend/users/UsersView.vue'
import RolesView from '@/views/backend/users/RolesView.vue'
import PermissionsView from '@/views/backend/users/PermissionsView.vue'
import AuthorizeView from '@/views/backend/users/AuthorizeView.vue'
import RoleUserView from '@/views/backend/users/RoleUserView.vue'
import DocumentConfigView from '@/views/backend/documents/DocumentConfigView.vue'
import DocumentsView from '@/views/backend/documents/DocumentsView.vue'
import DocumentCategoriesView from '@/views/backend/documents/DocumentCategoriesView.vue'
import FooterView from '@/views/backend/FooterView.vue'
import AdmissionApplicationFormView from '@/views/Admissions/AdmissionApplicationFormView.vue'
import DynamicDetailView from '@/views/dynamics/DynamicDetailView.vue'
import NewsConfigView from '@/views/backend/news/NewsConfigView.vue'
import DynamicNewsView from '@/views/backend/news/DynamicNewsView.vue'
import RegularNewsView from '@/views/backend/news/RegularNewsView.vue'
import MainNewsView from '@/views/backend/news/MainNewsView.vue'
import CustomerNewsView from '@/views/backend/news/CustomerNewsView.vue'
import DynamicDetailSubView from '@/views/dynamics/DynamicDetailSubView.vue'
import QuestionView from '@/views/backend/QuestionView.vue'
import DynamicDetailTDView from '@/views/dynamics/DynamicDetailTDView.vue'
import DynamicDetailClassroomView from '@/views/dynamics/DynamicDetailClassroomView.vue'
import SearchPageView from '@/views/search-page/SearchPageView.vue'
import LayoutAdjustmentView from '@/views/backend/LayoutAdjustmentView.vue'
import ApplicationView from '@/views/backend/ApplicationView.vue'
import MediaConfigView from '@/views/backend/media/MediaConfigView.vue'
import FooterDataView from '@/views/backend/FooterDataView.vue'
import SubscriptionDetailsView from '@/views/backend/SubscriptionDetailsView.vue'
import DynamicDetailCustomerView from '@/views/dynamics/DynamicDetailCustomerView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { noAuth: true },
    component: HomePageLayoutView
  },
  {
    path: '/company',
    name: 'company',
    meta: { noAuth: true },
    component: CompanyView,
    children: [
      {
        path: 'history-foundation',
        component: FoundationView
      },
      {
        path: 'quality-systemss',
        component: QualitySystemView
      },
      {
        path: 'location-map',
        component: LocationView
      },
      {
        path: 'Q&A',
        component: QandAView
      },
      {
        path: 'customer',
        name: 'customer',
        component: CustomerView,
        children: [
          {
            path: ':url',
            name: 'customer-detail',
            component: DynamicDetailCustomerView,
            props: true
          }
        ]
      },
      {
        path: 'contact',
        component: ContactView
      },
      {
        path: 'classroom-layout',
        component: ClassroomLayoutView
      },
      {
        path: ':url',
        component: DynamicDetailSubView,
        props: true
      }
    ]
  },
  {
    path: '/:url',
    name: 'dynamics',
    meta: { noAuth: true },
    component: DynamicDetailView,
    props: true
  },
  {
    path: '/news',
    name: 'news',
    meta: { noAuth: true },
    component: NewsView,
    children: [
      {
        path: ':url',
        name: 'NewsDetail',
        component: NewsDetailView,
        props: true
      }
    ]
  },
  {
    path: '/training-services',
    name: 'trainingServices',
    meta: { noAuth: true },
    component: TrainingServicesView,
    children: [
      {
        path: ':url',
        component: DynamicDetailSubView,
        props: true
      },
      {
        path: 'pilot-training',
        name: 'pilotTraining',
        component: PilotTrainingView,
        children: [
          {
            path: ':url',
            name: 'PilotTrainingDetail',
            component: TSDetailView,
            props: true
          }
        ]
      },
      {
        path: 'flight-attendant-training',
        name: 'FATraining',
        component: FATrainingView,
        children: [
          {
            path: ':url',
            name: 'FATrainingDetail',
            component: TSDetailView,
            props: true
          }
        ]
      },
      {
        path: 'flight-operations-dispatch-personnel-training',
        name: 'FODPTraining',
        component: FODPTrainingView,
        children: [
          {
            path: ':url',
            name: 'FODPTrainingDetail',
            component: TSDetailView,
            props: true
          }
        ]
      },
      {
        path: 'soft-skills-training',
        name: 'SSTraining',
        component: SSTrainingView,
        children: [
          {
            path: ':url',
            name: 'SSTrainingDetail',
            component: TSDetailView,
            props: true
          }
        ]
      },
      {
        path: 'aviation-english-training',
        name: 'AETraining',
        component: AETrainingView,
        children: [
          {
            path: ':url',
            name: 'AETrainingDetail',
            component: TSDetailView,
            props: true
          }
        ]
      },
      {
        path: 'aviation-career-guidance',
        name: 'ACGuidance',
        component: ACGuidanceView,
        children: [
          {
            path: ':url',
            name: 'ACGuidanceDetail',
            component: TSDetailView,
            props: true
          }
        ]
      }
    ]
  },
  {
    path: '/devices-utilities',
    meta: { noAuth: true },
    component: DevicesUtilitiesView,
    children: [
      {
        path: 'training-devices',
        name: 'training-devices',
        component: TrainingDevicesView,
        children: [
          {
            path: ':url',
            component: DynamicDetailTDView,
            props: true
          }
        ]
      },
      {
        path: 'classroom',
        name: 'classroom',
        component: ClassroomView,
        children: [
          {
            path: ':url',
            component: DynamicDetailClassroomView,
            props: true
          }
        ]
      },
      {
        path: ':url',
        component: DynamicDetailSubView,
        props: true
      }
    ]
  },
  {
    path: '/admissions',
    name: 'admissions',
    meta: { noAuth: true },
    component: AdmissionView,
    children: [
      {
        path: ':url',
        component: DynamicDetailSubView,
        props: true
      },
      {
        path: 'student-pilot',
        name: 'studentPilot',
        component: StudentPilotView,
        children: [
          {
            path: ':url',
            name: 'SPDetail',
            component: SPDetailView,
            props: true
          }
        ]
      },
      {
        path: 'application-form',
        name: 'applicationForm',
        component: AdmissionApplicationFormView
      }
    ]
  },
  {
    path: '/information-for-trainees',
    component: ForStudentView,
    name: 'infoTrainees',
    meta: { noAuth: true },
    children: [
      {
        path: ':url',
        component: DynamicDetailSubView,
        props: true
      },
      // {
      //   path: 'library',
      //   component: LibraryView
      // },
      // {
      //   path: 'training-schedule',
      //   component: TrainingScheduleView,
      //   name: 'trainingSchedule',
      //   children: [
      //     {
      //       path: ':url',
      //       name: 'TrainingScheduleDetail',
      //       component: TrainingScheduleDetailView,
      //       props: true
      //     }
      //   ]
      // },
      {
        path: 'evaluation-form',
        component: EvaluationFormView
      }
    ]
  },
  {
    path: '/site-map',
    component: WebsiteStructureView,
    meta: { noAuth: true }
  },
  {
    path: '/login',
    component: LoginPage,
    meta: { noAuth: true }
  },
  {
    path: '/management-details',
    name: 'backend',
    component: BackendView,
    children: [
      {
        path: 'layout-adjustments',
        component: LayoutAdjustmentView
      },
      {
        path: 'menus',
        name: 'menusView',
        component: MenusView
      },
      {
        path: 'sub-menus',
        name: 'subMenus',
        component: SubMenusView
      },
      {
        path: 'training-services',
        component: TrainingServicesBeView
      },
      {
        path: 'training-service-details',
        component: TrainingServiceDetailsBeView
      },
      {
        path: 'news-config',
        component: NewsConfigView,
        children: [
          {
            path: 'dynamic-news',
            component: DynamicNewsView
          },
          {
            path: 'regular-news',
            component: RegularNewsView
          }, {
            path: 'main-news',
            component: MainNewsView
          },
          {
            path: 'customer-news',
            component: CustomerNewsView
          }
        ]
      },
      {
        path: 'admissions',
        component: AdmissionBeView
      },
      {
        path: 'training-schedules',
        component: TrainingSchedulesBeView
      },
      {
        path: 'training-schedules-details',
        component: TrainingScheduleDetailsBeView
      },
      {
        path: 'questions',
        component: QuestionView
      },
      {
        path: 'applications',
        component: ApplicationView
      },
      {
        path: 'subscriptions',
        component: SubscriptionDetailsView
      },
      {
        path: 'media-config',
        component: MediaConfigView,
        children: [
          {
            path: 'media-categories',
            component: MediaCategoriesBeView
          },
          {
            path: 'media',
            component: MediaBeView
          }
        ]
      },
      // {
      //   path: 'media-categories',
      //   component: MediaCategoriesBeView
      // },
      // {
      //   path: 'media',
      //   component: MediaBeView
      // },
      {
        path: 'user-config',
        component: UsersConfigView,
        children: [
          {
            path: 'account',
            component: AccountView
          },
          {
            path: 'users-management',
            component: UsersView
          },
          {
            path: 'roles-management',
            component: RolesView
          },
          {
            path: 'permissions-management',
            component: PermissionsView
          },
          {
            path: 'authorize-management',
            component: AuthorizeView
          },
          {
            path: 'group-management',
            component: RoleUserView
          }
        ]
      },
      {
        path: 'document-config',
        component: DocumentConfigView,
        children: [
          {
            path: 'document-categories',
            component: DocumentCategoriesView
          },
          {
            path: 'documents',
            component: DocumentsView
          }
        ]
      },
      {
        path: 'contact',
        component: FooterView
      },
      {
        path: 'footer',
        component: FooterDataView
      }
    ]
  },
  {
    path: '/search-page',
    name: 'searchPage',
    component: SearchPageView,
    meta: { noAuth: true }
  },
  {
    path: '/no-info',
    component: NoInfoView,
    meta: { noAuth: true }
  }
  // {
  //   path: '/:noInfo(.*)',
  //   component: NoInfoView,
  //   meta: { noAuth: true }
  // }
]
export default routes
